import axiosInstanceWeb from './axiosInstance';
const API_URL_TASK_COUNT = "tasks/count";
const API_URL_TASK = "tasks";
const API_URL_SMARTVIEW = "/smartviews";

export const apiGetTaskCount = async (postBody) => {
  try {
    const response = await axiosInstanceWeb.post(API_URL_TASK_COUNT, postBody);
    return response.data;
  } catch (error) {
    console.error("Error fetching task count:", error);
    return null; // Return null if there's an error
  }
};
export const apiGetSmartViewsCount = async (postBody, type) => {
  try {
    const response = await axiosInstanceWeb.post(
      `${API_URL_SMARTVIEW}/${type}`,
      postBody,
    );
    return { count: response?.data?.recordCount };
  } catch (error) {
    console.error("Error fetching task count:", error);
    return null; // Return null if there's an error
  }
};

export const apiGetTask = async (postBody) => {
  try {
    const response = await axiosInstanceWeb.post(API_URL_TASK, postBody, );
    return response.data;
  } catch (error) {
    console.error("Error fetching task count:", error);
    return null; // Return null if there's an error
  }
};

export const apiGetSmartViewsEntityList = async (postBody, type) => {
  try {
    const response = await axiosInstanceWeb.post(`${API_URL_SMARTVIEW}/${type}`, postBody);
    return response.data;
  } catch (error) {
    console.error("Error fetching task count:", error);
    return null; // Return null if there's an error
  }
};

export const apiGetWebLaunchBar = async () => {
  try {
    const response = await axiosInstanceWeb.get("/launchers/user");
    return response.data;
  } catch (error) {
    console.error("Error fetching launch bar data:", error);
    return { payload: { config: [] } };
  }
};

export const fetchImageUrl = async (key) => {
  try {
    const response = await axiosInstanceWeb.post(`/widgets/signedUrl`, {
      keys: [key]
    });
    return response.data.urls[0]; // Adjust the response to match the actual structure of your API response
  } catch (error) {
    console.error("Error fetching image URL:", error);
    return null; // Return null if there's an error
  }
};
